/**
 * Typed accessor for environment-specific config (admin dashboard).
 *   npm run dev          -> .env.development  (Dev URLs)
 *   npm run build        -> .env.dev-deploy   (Dev URLs, default safe)
 *   npm run build:prod   -> .env.prod-deploy  (Prod URLs, deploy script only)
 */

interface AdminEnv {
  readonly name: 'dev' | 'prod';
  readonly edgeFnUrl: string;
  readonly isDev: boolean;
}

function readEnv(): AdminEnv {
  const name = (import.meta.env.VITE_ENV_NAME as 'dev' | 'prod' | undefined) ?? 'dev';
  if (name !== 'dev' && name !== 'prod') {
    throw new Error(`VITE_ENV_NAME must be 'dev' or 'prod', got: ${name}`);
  }
  return {
    name,
    edgeFnUrl: (import.meta.env.VITE_EDGE_FN_URL as string) ?? '',
    isDev: name === 'dev',
  };
}

export const env = readEnv();
